import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../../config";
import "../Styles/PlanillarPartidoComponent.css";
import defaulUser from "../../../assets/defaultUser.png"
const EstadisticasPartidoComponentLogout = ({ idPartido, idEquipo }) => {
  const [estadisticas, setEstadisticas] = useState([]);

  useEffect(() => {
    const obtenerEstadisticas = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}get-estadisticas-partido/${idPartido}/${idEquipo}` 
        );
        setEstadisticas(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    obtenerEstadisticas();
  }, [idPartido, idEquipo]);

  return (
    <div className="container mt-4">
      <table className="table table-bordered mt-3">
        <thead>
        <tr>
        <th scope="col"></th>
            <th scope="col">Nombre</th>
            <th scope="col">Inicialista</th>
            <th scope="col">
              T.A
              <span className="tarjeta-amarela" />
            </th>
            <th scope="col">
              T.R
              <span className="tarjeta-roja" />
            </th>
            <th scope="col">Puntos</th>
            <th scope="col">Observación</th>
          </tr>
        </thead>
        <tbody>
          {estadisticas.map((estadistica) => (
            <tr key={estadistica.id}>
              <td>
                <img
                            src={estadistica.jugador.fotografiaPath || defaulUser} 
                            alt={`${estadistica.jugador.nombreJugador} Foto`}
                            className="goleador-foto"
                          />
              </td>
              <td>
                {estadistica.jugador.nombres} {estadistica.jugador.apellidos} #{estadistica.numeroCamiseta}
              </td>
              <td>{estadistica.inicialista ? 'Sí' : 'No'}</td>
              <td>{estadistica.tarjetaAmarilla}</td>
              <td>{estadistica.tarjetaRoja}</td>
              <td>{estadistica.puntos}</td>
              <td>{estadistica.observacion}</td>
            </tr>
          ))}
          {estadisticas.length === 0 && (
            <tr>
              <td colSpan="6" className="text-center">
                No hay estadísticas disponibles
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export { EstadisticasPartidoComponentLogout };
